module.exports = __webpack_public_path__ + "static/media/30.3644be54.jpg";